import styles from './homeContent.module.scss';
import ScrolDown from '../scroll-down';
import { useEffect, useState } from 'react';
import home from '../../apis/home';
export default function HomeContent(props) {
  const [homeData, setHomeData] = useState({});

  useEffect(() => {
    home
      .getContent()
      .then((res) => {
        setHomeData(res.data[0]);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  return (
    <>
      <div className={styles['HomeContent']}>
        <div className={styles['content-image']}>
          <div data-aos="zoom-in">
            <img src={homeData.image1} alt="" />
          </div>
          <div data-aos="zoom-in" data-aos-delay={200}>
            <img src={homeData.image2} alt="" />
          </div>
        </div>
        <div className={styles['content-text']}>
          <h1 align="center">{homeData.title}</h1>
          <p align="center">{homeData.content}</p>
        </div>
        <ScrolDown fullpageApi={props.fullpageApi} />
      </div>
    </>
  );
}
